/* eslint-disable no-undef */
// @flow strict
import * as React from 'react';
import styles from './select.css';

export type Props<T: { [string]: string }> = {|
  changeSelection: (?string) => void,
  itemDisplayProp: $Keys<T>,
  itemKeyProp: $Keys<T>,
  items: Array<T>,
  itemValueProp: $Keys<T>,
  label: string,
  noSelectionValue: string,
  selectedItemValue: ?string,
  dataCyValue: string,
|};

const Select = <T: { [string]: string }>(props: Props<T>): React.Node => {
  return (
    <div className={styles.nweaSelectPanel}>
      <label>
        <b
          className={`nwea-ds-v1-typography-subtitle ${styles.nweaSelectLabel}`}
        >
          {props.label}
        </b>
        <br />
        <select
          className={`nwea-ds-v1-typography-body-copy-medium ${styles.nweaSelect}`}
          value={
            props.selectedItemValue === null ? 'none' : props.selectedItemValue
          }
          onChange={(e) => {
            e.stopPropagation();
            const selectedIndex = e.target.selectedIndex;
            if (selectedIndex === 0) {
              props.changeSelection(null);
            } else {
              props.changeSelection(e.target.value);
            }
          }}
          data-cy={props.dataCyValue}
        >
          <option value="none">{props.noSelectionValue}</option>
          {props.items.map((item) => {
            return (
              <option
                value={item[props.itemValueProp]}
                key={item[props.itemKeyProp]}
              >
                {item[props.itemDisplayProp]}
              </option>
            );
          })}
        </select>
      </label>
    </div>
  );
};

export default Select;
